export const resizeByLink = (link, keyword) => {
  if (link) {
    const linkSplit = link.split(keyword);
    const resizedLink = `${linkSplit[0]}upload/w_160,h_160,c_scale${linkSplit[1]}`;
    return resizedLink;
  }
  return null;
};
